// Calls our backend's enriched-events cache. The backend handles the whole
// SeatGeek→TM→Calendar price chain with TTL/stale-while-revalidate, so this
// is just a JSON GET — no per-event waterfalls.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5001';

export const fetchTeamEvents = async (teamName, sport) => {
  if (!teamName) return { events: [], generatedAt: 0 };

  const params = new URLSearchParams({ teamName });
  if (sport) params.append('sport', sport);

  const r = await fetch(`${BACKEND_URL}/api/teams/events?${params}`);
  if (!r.ok) {
    const body = await r.text().catch(() => '');
    throw new Error(`Failed to fetch team events (${r.status}): ${body.slice(0, 120)}`);
  }
  return r.json();
};
